import { WorkflowStatusType } from './workflow-status-type';

export const WORKFLOW_HOLDING_ROUTE = 'workflow-holding';
export const WORKFLOW_REVIEW_ROUTE = 'manual-review';

export function getWorkflowBlockingRoute(
  userRequestWorkflowStatusTypeId: WorkflowStatusType | null | undefined
): string | null {
  switch (userRequestWorkflowStatusTypeId) {
    case WorkflowStatusType.Pending:
    case WorkflowStatusType.FeedProcessing:
    case WorkflowStatusType.FeedFailure:
      return WORKFLOW_HOLDING_ROUTE;
    case WorkflowStatusType.ManualReviewPending:
    case WorkflowStatusType.NeedsInfo:
    case WorkflowStatusType.InProgress:
      return WORKFLOW_REVIEW_ROUTE;
    case WorkflowStatusType.Completed:
    default:
      return null;
  }
}
